import { useContext, FC, useState } from 'react'

import CalendarFilterTemplateContext, { FilterDate, CalendarFilterTemplateType } from './Context'
import { SubmitedFilterDates } from 'components/miscellaneous/CalendarFilter'

type Props = {
  onSubmitFilter: (values: SubmitedFilterDates) => void
  children: JSX.Element
}

const CalendarFilterTemplateProvider: FC<Props> = ({ onSubmitFilter, children }) => {
  const [filterDate, setFilterDate] = useState<FilterDate>({})

  return (
    <CalendarFilterTemplateContext.Provider value={{ filterDate, setFilterDate, onSubmitFilter }}>
      {children}
    </CalendarFilterTemplateContext.Provider>
  )
}

export default CalendarFilterTemplateProvider

export const useCalendarFilterTemplate = () => useContext<CalendarFilterTemplateType>(CalendarFilterTemplateContext)
